import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { withCache } from '../with-cache/index.tsx';

export const performGetRequestWithCache = withCache(performGetRequest);
